import { createApiInstance, LONG_TIMEOUT_CONFIG } from './config'

// 为APK2使用长超时配置（适合大文件上传）
const apk2API = createApiInstance(LONG_TIMEOUT_CONFIG)

// 使用统一的响应拦截器，已在config.js中配置

export default {
  // 公共接口
  
  // 获取最新APK2版本
  getLatestAPK2(game = 'default') {
    return apk2API.get('/apk/latest2', { params: { game } })
  },

  // 获取版本历史
  getVersionHistory(game = '冒险岛枫星') {
    return apk2API.get('/apk/history', { params: { game } })
  },

  // 获取APK2下载地址
  getDownloadUrl2(id) {
    return apk2API.get(`/apk/${id}/download2`)
  },

  // 代理下载APK2文件
  proxyDownloadApk2(id) {
    return apk2API.get(`/apk/${id}/proxy-download2`, {
      responseType: 'blob'
    })
  },

  // 通过路径代理下载文件
  proxyDownloadByPath2(filePath) {
    return apk2API.get(`/apk/proxy-download2/${filePath}`, {
      responseType: 'blob'
    })
  },

  // 获取下载统计信息
  getDownloadStats2() {
    return apk2API.get('/apk/download-stats2')
  },

  // 管理员接口

  // 上传APK2（支持真实上传进度，使用坚果云WebDAV）
  uploadAPK2(formData, onUploadProgress) {
    return apk2API.post('/admin/apk2/upload', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      },
      timeout: 600000, // 单独为上传设置10分钟超时
      onUploadProgress: onUploadProgress // 上传进度回调
    })
  },

  // 获取APK2列表
  getAPK2List(params = {}) {
    const defaultParams = {
      page: 1,
      size: 10
    }
    return apk2API.get('/admin/apk2/list', { 
      params: { ...defaultParams, ...params } 
    })
  },

  // 获取单个APK2信息
  getAPK2(id) {
    return apk2API.get(`/admin/apk2/${id}`)
  },

  // 更新APK2信息
  updateAPK2(id, data) {
    return apk2API.put(`/admin/apk2/${id}`, data)
  },

  // 删除APK2
  deleteAPK2(id) {
    return apk2API.delete(`/admin/apk2/${id}`)
  },

  // 切换APK2状态
  toggleAPK2Status(id, isActive) {
    const formData = new FormData()
    formData.append('isActive', isActive)
    return apk2API.put(`/admin/apk2/${id}/status`, formData)
  },

  // 获取APK2下载链接（管理员）
  getAPK2DownloadUrl(id) {
    return apk2API.get(`/admin/apk2/${id}/download`)
  },

  // 测试坚果云WebDAV连接
  testWebDAVConnection() {
    return apk2API.get('/admin/apk2/test-webdav')
  }
}
